import { Box, Button } from '@mui/material';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DialogCustom from 'commons/DialogCustom';
import Text from 'commons/Text';
import API from 'configs/API';
import SectionWrapper from 'pages/EditArtistProfile/commons/SectionWrapper';
import { axiosDelete, axiosPost } from 'utils/apis/axios';
import { ToastTopHelper } from 'utils/utils';

import CollectionFormBody from './components/CollectionFormBody';
import CollectionList from './components/CollectionList';
import DialogEditCollection from './components/DialogEditCollection';
import useStyles from './styles';

const ArtistCollection = () => {
  const classes = useStyles();
  const [isPublic, setIsPublic] = useState(true);
  const [collection, setCollection] = useState('');
  const [selectedCollection, setSelectedCollection] = useState({});
  const [isShowDialogDelete, setIsShowDialogDelete] = useState(false);
  const [isShowDialog, setIsShowDialog] = useState(false);
  const { t } = useTranslation();
  const { data: listCollection = [] } = useQuery({
    queryKey: [API.AUTH.COLLECTION.LIST],
  });

  const queryClient = useQueryClient();

  const handleSwitchChange = (e) => {
    const isHidePrice = e.target.checked;
    setIsPublic(isHidePrice);
  };

  const handleChangeCollection = (e) => {
    const value = e.target.value;
    setCollection(value);
  };

  const handleCancelCollection = () => {
    setIsShowDialogDelete(false);
  };

  const handleOpenDialogDelete = (item) => {
    setSelectedCollection(item);
    setIsShowDialogDelete(true);
  };

  const handleOpenDialogEdit = (item) => {
    setSelectedCollection(item);
    setIsShowDialog(true);
  };

  const handleCancelDialogEdit = () => {
    setIsShowDialog(false);
  };

  const handleSubmitDeleteCollection = async () => {
    const { success } = await axiosDelete(API.AUTH.COLLECTION.DETAIL(selectedCollection?.id));
    if (success) {
      queryClient.invalidateQueries({ queryKey: [API.AUTH.COLLECTION.LIST] });
      setIsShowDialogDelete(false);
      ToastTopHelper.success(t('delete_success'));
    }
  };

  const createCollection = async () => {
    const formData = {
      name: collection,
      is_public: true,
    };
    const { success } = await axiosPost(API.AUTH.COLLECTION.CREATE, formData);
    if (success) {
      queryClient.invalidateQueries({ queryKey: [API.AUTH.COLLECTION.LIST] });
      setCollection('');
      setIsPublic(true);
      ToastTopHelper.success(t('create_successfully'));
    }
  };

  return (
    <SectionWrapper heading={t('institutional_collections')}>
      <Box className={classes.bodyBox}>
        <CollectionFormBody
          collection={collection}
          onCollectionChange={handleChangeCollection}
          isPublic={isPublic}
          onSwitchChange={handleSwitchChange}
        />

        <div className={classes.wrapButtonAdd}>
          <Button
            variant="contained"
            disabled={!collection}
            onClick={createCollection}
            className={classes.buttonAdd}
          >
            {t('add')}
          </Button>
        </div>
      </Box>
      <Text className={classes.textAddEventAutomatic}>{t('added_events_will_automatically')}</Text>

      <CollectionList
        listCollection={listCollection}
        onClickOpenDialogDelete={handleOpenDialogDelete}
        onClickOpenDialogEdit={handleOpenDialogEdit}
      />

      <DialogEditCollection
        isShowDialog={isShowDialog}
        onCancel={handleCancelDialogEdit}
        selectedCollection={selectedCollection}
        key={isShowDialog}
      />

      <DialogCustom
        isShowDialog={isShowDialogDelete}
        textCancel={t('cancel')}
        dialogTitle={t('delete_publication')}
        textSubmit={t('delete')}
        onCancel={handleCancelCollection}
        onSubmit={handleSubmitDeleteCollection}
      >
        {t('are_you_sure_you_want_delete_your', { name: t('institutional_collections') })}
        <Text
          bold
          mt={4}
        >
          {selectedCollection?.name}
        </Text>
      </DialogCustom>
    </SectionWrapper>
  );
};

export default ArtistCollection;
